import React from 'react';
import { get } from 'lodash';
import {
  getLastPage,
  PAGINATION_TYPE_MULTIPLE_PAGES,
  Section,
} from '@wix/communities-blog-client-common';
import { connect } from '../../common/components/runtime-context';

import { MapRuntimeToProps } from '../../common/components/runtime-context/connect';
import {
  getCurrentPage,
  getEntityCount,
  getLastPageIndex,
  getPaginationPageSize,
  getPaginationType,
} from '../../common/selectors/pagination-selectors';

export type WithPaginationSettings = {
  paginationType: string;
  page: number;
  pageSize: number;
  lastPage: number;
  isValidPage: boolean;
  entityCount: number;
  showPagination: boolean;
};

export type WithPaginationSettingsOwnProps = {
  params?: { page?: string };
};

const mapRuntimeToProps =
  (
    section: Section,
  ): MapRuntimeToProps<
    WithPaginationSettings,
    WithPaginationSettingsOwnProps
  > =>
  (state, ownProps) => {
    const paginationType = getPaginationType(state, section);

    const page =
      paginationType === PAGINATION_TYPE_MULTIPLE_PAGES
        ? Number(get(ownProps, 'params.page', getCurrentPage(state, 'posts')))
        : getLastPageIndex(state, 'posts');

    const pageSize = getPaginationPageSize(state, section);
    const entityCount = getEntityCount(state, 'posts');
    const lastPage = getLastPage(entityCount, pageSize);
    return {
      paginationType,
      page,
      pageSize,
      lastPage,
      isValidPage: page === 1 || (page > 1 && page <= lastPage),
      entityCount,
      showPagination: paginationType === PAGINATION_TYPE_MULTIPLE_PAGES,
    };
  };

export default function withPaginationSettings(section: Section) {
  return (WrappedComponent: React.ComponentType<WithPaginationSettings>) =>
    connect(mapRuntimeToProps(section))(WrappedComponent);
}
